import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { extend } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import Stream from 'flarum/common/utils/Stream';
// @ts-ignore — lodash-es does not ship its own declaration files
import throttle from 'lodash-es/throttle';
import Icon from 'flarum/common/components/Icon';
import classList from 'flarum/common/utils/classList';
export default function () {
  extend('flarum/forum/components/PostStream', 'endItems', function (items) {
    if (this.discussion.attribute('canViewWhoTypes')) {
      var _app$session;
      const typingUsers = Object.keys(this.getTypingUsers());
      const count = typingUsers.length;
      const max = 3;
      const classes = classList(['TypingUsersContainer', count > 0 && 'TypingUsersContainer-active']);
      const typingIcon = count > 0 ? 'fas fa-ellipsis-h fa-beat' : 'fas fa-pause';
      const namedUsers = typingUsers.slice(0, max).join(', ');
      let showUsers = true;
      if ((_app$session = app.session) != null && _app$session.user) {
        var _app$session$user$pre, _app$session$user$pre2;
        showUsers = (_app$session$user$pre = (_app$session$user$pre2 = app.session.user.preferences()) == null ? void 0 : _app$session$user$pre2['flarum-realtime.typing-indicator-full']) != null ? _app$session$user$pre : true;
      }
      items.add('usersTyping', m("div", {
        className: classes,
        key: "typing"
      }, m("div", {
        className: "TypingUsers"
      }, m(Icon, {
        name: typingIcon
      }), count > 0 ? showUsers ? app.translator.trans('flarum-realtime.forum.typing-indicator.users-are-typing', {
        users: namedUsers,
        count,
        others: Math.max(count - max, 0)
      }) : app.translator.trans('flarum-realtime.forum.typing-indicator.people-are-typing', {
        number: count
      }) : app.translator.trans('flarum-realtime.forum.typing-indicator.no-activity'))), 70);
    }
  });
  extend('flarum/forum/components/PostStream', 'oninit', function () {
    this.previousContent = Stream('');
    this.usersTyping = Stream({});
    this.typingTruncationListener = null;
    this.typingListener = null;
    this.getTypingUsers = () => {
      const invalidateWhen = Date.now() - 6000;
      const users = _objectSpread({}, this.usersTyping());
      let latestTime = null;
      for (const displayName of Object.keys(users)) {
        if (users[displayName] < invalidateWhen) {
          delete users[displayName];
        } else if (!latestTime || latestTime < users[displayName]) {
          latestTime = users[displayName];
        }
      }
      this.usersTyping(users);
      if (latestTime && this.typingTruncationListener) {
        clearTimeout(this.typingTruncationListener);
      }
      if (latestTime) {
        this.typingTruncationListener = setTimeout(() => m.redraw(), latestTime - Date.now());
      }
      return users;
    };
    this.userTyping = data => {
      const users = _objectSpread({}, this.usersTyping());
      if (!data.discloseOnline) {
        data.displayName = String(app.translator.trans('flarum-realtime.forum.typing-indicator.anonymous-user'));
      }
      users[data.displayName] = data.time;
      this.usersTyping(users);
      m.redraw();
    };
    this.actorIsTyping = () => {
      var _app$session$user, _app$websocket_channe, _app$session$user2;
      const discloseOnline = (_app$session$user = app.session.user) == null || (_app$session$user = _app$session$user.preferences()) == null ? void 0 : _app$session$user.discloseOnline;
      (_app$websocket_channe = app.websocket_channels.discussion) == null || _app$websocket_channe.trigger('client-typing', {
        displayName: discloseOnline ? (_app$session$user2 = app.session.user) == null ? void 0 : _app$session$user2.displayName() : '[anonymous]',
        discloseOnline,
        time: Date.now()
      });
    };
    this.checkTyping = () => {
      var _fields, _fields$content;
      if (!app.composer.composingReplyTo(this.discussion)) return;
      const currentContent = (_fields = app.composer.fields) == null || (_fields$content = _fields.content) == null ? void 0 : _fields$content.call(_fields);
      if (this.previousContent() !== currentContent) {
        this.actorIsTyping();
        this.previousContent(currentContent);
      }
    };
  });
  extend('flarum/forum/components/PostStream', 'view', function () {
    if (app.forum.attribute('websocket.disallow_connection')) return;
    if (this.discussion && app.composer.editor && !this.typingListener) {
      const checkFn = throttle(() => this.checkTyping(), 2000);
      this.typingListener = setInterval(checkFn, 1000);
    }
    if (this.discussion) {
      app.websocket_channels.discussion = app.websocket.subscribe('private-typing=' + m.route.param('id').match(/[0-9]+/));
      if (this.discussion.attribute('canViewWhoTypes')) {
        app.websocket_channels.discussion.bind('client-typing', data => {
          this.userTyping(data);
        });
      }
    }
  });
  extend('flarum/forum/components/PostStream', 'onremove', function () {
    if (this.typingListener) clearInterval(this.typingListener);
    if (this.typingTruncationListener) clearTimeout(this.typingTruncationListener);
  });
}